import { Key } from 'react';

import { TreeNode } from '../Tree/type';
export const searchTree = (searchValue: string, treeData: TreeNode[] = []) => {
  const result: TreeNode[] = [];
  treeData.forEach((item) => {
    const tempTitle = item.title || '';
    if (
      tempTitle.toString().toLowerCase().indexOf(searchValue.toLowerCase()) > -1
    ) {
      result.push(item);
    } else if (item.children) {
      const children = searchTree(searchValue, item.children);
      if (children.length > 0) {
        result.push({
          ...item,
          children,
        });
      }
    }
  });
  return result;
};

export const traverseTreeData = ({
  treeData = [],
  callback = () => {
    return null;
  },
  parentId = null,
  replaceName = 'children',
}: {
  treeData: any[];
  callback: (item: any, index: number, parentId: Key | null) => void;
  parentId?: Key | null;
  replaceName?: string;
}) => {
  treeData.forEach((item, index) => {
    callback(item, index, parentId);
    if (item[replaceName] && item[replaceName].length > 0) {
      traverseTreeData({
        treeData: item[replaceName],
        callback,
        parentId: item.key,
        replaceName,
      });
    }
  });
};

export const flatTree = ({
  treeData = [],
  callback = () => {
    return null;
  },
  replaceName = 'children',
}: {
  treeData: any[];
  callback?: (item: any) => void;
  replaceName?: string;
}) => {
  const flatArr: any[] = [];
  treeData.forEach((item) => {
    const tempItem = { ...item };
    if (item[replaceName]) {
      delete tempItem[replaceName];
    }
    callback(tempItem);
    flatArr.push(tempItem);
    if (item[replaceName] && item[replaceName].length > 0) {
      flatArr.push(
        ...flatTree({ treeData: item[replaceName], callback, replaceName })
      );
    }
  });
  return flatArr;
};

export const searchAllKey = (
  keys: Key[],
  sonParMap: Map<Key, Key | null>
): Key[] => {
  const allKeys: Key[] = [];
  function search(value: Key) {
    allKeys.push(value);
    const nextKey = sonParMap.get(value);
    if (nextKey) {
      search(nextKey);
    }
  }
  keys.forEach((key) => search(key));
  return allKeys;
};

export const reorganizeTree = (
  nodes: any[],
  id = null,
  link = 'parentId'
): any[] => {
  return nodes
    .filter((node) => node[link] === id)
    .map((item) => {
      return {
        ...item,
        children: reorganizeTree(nodes, item.key, link),
      };
    });
};
